// 청산 당시 이벤트의 비율을 사용한다. 현재 전략의 도달 플래그로 과거 청산을 추정하지 않는다.
export function formatExitReason(reason, event = {}, labels = {}) {
  if (!reason) return '';
  const reasonObject = typeof reason === 'object' ? reason : null;
  const code = reasonObject
    ? reasonObject.reason || reasonObject.code || reasonObject.type
    : reason;

  if (code === 'max_limit_count_stop_loss') return '동일라인 손실제한';
  if (code === 'trailing_stop') {
    const ratio = Number(event?.trailing_ratio ?? reasonObject?.trailing_ratio);
    const percent = { 0.6: 60, 0.8: 80, 0.85: 85 }[ratio];
    // 비율이 없는 과거 기록은 특정 조건으로 단정하지 않는다.
    return percent ? `가격${percent}%익절` : '트레일링 익절';
  }

  return labels[code] || (reasonObject ? JSON.stringify(reasonObject) : reason);
}
